/**
 * An account's optional LinkedIn profile URL: the form's half of the rule. Read
 * by the client user forms (#591) and the administrator forms (#617), which is
 * why it lives here rather than in either feature's `_shared/`.
 *
 * Same contract as the backend's `domain/user-linkedin-url.ts`: both call the
 * shared `@shared/constants/profile-name` helpers and judge the NORMALISED URL,
 * so a URL this form accepts cannot come back as a 400, and what is stored is the
 * normalised spelling. Empty is valid; the field is optional. Pure.
 */
import { isValidLinkedInProfileUrl, normalizeLinkedInUrl } from '@shared/constants/profile-name';

export const LINKEDIN_URL_INVALID_MESSAGE =
  'Enter a LinkedIn member profile URL (https://www.linkedin.com/in/…).';

/** The field's error message, or `undefined` when it is empty or a member profile. */
export function linkedInUrlError(raw: string): string | undefined {
  const url = raw.trim();
  if (!url) return undefined;
  return isValidLinkedInProfileUrl(normalizeLinkedInUrl(url))
    ? undefined
    : LINKEDIN_URL_INVALID_MESSAGE;
}

/** What the request body carries: the normalised URL, or `null` for "none". */
export function toLinkedInUrlBody(raw: string): string | null {
  const url = raw.trim();
  return url ? normalizeLinkedInUrl(url) : null;
}
